export default __webpack_public_path__ + "static/media/icon-14.b7481495.png";